import FutureHouseForm from "./components/FutureHouseForm";
import FutureHouseFrame from "./components/FutureHouseFrame";
import UserAccountRoutes from "../front_user_account/routes";

export default [
    {
        path: "/future-house-awards",
        name: "future-house-frame",
        meta: {
            auth: true,
            basePath: true,
            award: "house",
            awardName: "Future House Awards",
        },
        component: FutureHouseFrame,
        children: [
            {
                path: "",
                component: FutureHouseForm,
                name: "future-house-form",
            },
            ...UserAccountRoutes,
        ],
    },
];
